import { render, staticRenderFns } from "./QuestionBankBuild.vue?vue&type=template&id=008e71a8&scoped=true"
import script from "./QuestionBankBuild.vue?vue&type=script&lang=js"
export * from "./QuestionBankBuild.vue?vue&type=script&lang=js"
import style0 from "./QuestionBankBuild.vue?vue&type=style&index=0&id=008e71a8&prod&lang=scss&scoped=true"
import style1 from "./QuestionBankBuild.vue?vue&type=style&index=1&id=008e71a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e71a8",
  null
  
)

export default component.exports